import React from "react";
import { SearchBox } from "react-instantsearch";

let timerId = undefined;
let timeout = 200;

function queryHook(query, search) {
  if (timerId) {
    clearTimeout(timerId);
  }

  timerId = setTimeout(() => search(query), timeout);
}

const AlgoliaSearchBar = () => {
  return (
    <div className="search-bar-container">
      <SearchBox
        classNames={{
          root: "search-box-root",
          form: "search-box-form",
          input: "search-bar",
          submit: "search-box-submit",
          reset: "search-box-reset",
        }}
        placeholder="search for something..."
        submitIconComponent={() => null} // Hide submit button
        resetIconComponent={() => null} // Hide reset button
        queryHook={queryHook}
      />
    </div>
  );
};

export default AlgoliaSearchBar;
